import React, { Fragment } from 'react';
import { Row, Col } from 'react-bootstrap';
import logoimg from '../../assets/images/logo.png';
import saude from '../../assets/images/logo-saude.png';
import '../../styles/header.scss';
import { slide as Menu } from 'react-burger-menu'

function HeaderSaude() {
    return (
        <Fragment>
            <header className='header'>
                <Row xs={2}>
                    <Col xs={10} lg={6}>
                            <img src={saude} className='transp' alt="Secretaria Municipal de Saúde e Combate às Drogas" />
                    </Col>
                </Row>
                <Menu right>
                    <a className="menu-item" href="https://prefeituramacuco.rj.gov.br">Site da Prefeitura</a>
                </Menu>
            </header>
        </Fragment >

    )
}

export default HeaderSaude;